import { useEffect } from "react";
import Loader from "../components/widgets/Loader";
import userManager from "../util/userManager";
import { emit } from "../util/ibuki";

const Logout = () => {
	useEffect(() => {
		setTimeout(async () => {
			// Emit message for logout
			emit("logOut");

			// Sign out of IDP
			const userIdToken = (await userManager.getUser())?.id_token;
			userManager.signoutRedirect({ id_token_hint: userIdToken });
		}, 2000);
	}, []);

	return (
		<div className="h-screen flex overflow-hidden bg-primary text-primary">
			<Loader />
		</div>
	);
};

export default Logout;
